// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1265":"11c5b3d1","2945":"2c90259a","4894":"366ccb1a"}[chunkId] + ".chunk.css";
};